import {
  HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, Observable, tap, throwError } from 'rxjs';

@Injectable()
export class ResponseInterceptor implements HttpInterceptor {

  constructor() { }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      tap(async (event: HttpEvent<any>) => {

        if (event instanceof HttpResponse) {
          if (event.status === 200) {

          }
        }

      }),
      catchError((err: any, caught: Observable<HttpEvent<any>>) => {

        return throwError(() => err);
      })
    );
  }
}
